import React from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import { isNewWebsitePage } from '../utils/routeOverrides';

const isSSR = typeof window === 'undefined';

/**
 * Check if current page is a new website page
 */
const checkIsNewWebsitePage = () => {
  if (isSSR) return false;
  const pathname = window.location.pathname;
  return isNewWebsitePage(pathname, true) || isNewWebsitePage(pathname, false);
};

// Compute once at module load time (before React renders)
const isNewWebsite = !isSSR && checkIsNewWebsitePage();

/**
 * A wrapper around PersistGate that conditionally blocks rendering.
 * - SSR: always render children (no PersistGate blocking)
 * - New website pages: render children immediately (no blocking)
 * - Ordering pages: wait for redux rehydration (normal PersistGate behavior)
 */
const SmartPersistGate = ({ persistor, children }) => {
  // During SSR or for new website pages, render immediately
  if (isSSR || isNewWebsite) {
    return children;
  }

  // For ordering pages (client-side only), use normal PersistGate behavior
  return (
    <PersistGate loading={null} persistor={persistor}>
      {children}
    </PersistGate>
  );
};

export default SmartPersistGate;